import PT from 'prop-types'

export const imagesProp = PT.arrayOf(PT.shape({
  id: PT.string.isRequired,
  width: PT.number.isRequired,
  height: PT.number.isRequired,
  original: PT.string.isRequired,
  thumbs: PT.arrayOf(PT.shape({
    name: PT.string.isRequired,
    width: PT.number.isRequired,
    height: PT.number.isRequired,
  })),
}))

export const postProp = PT.shape({
  _id: PT.string.isRequired,
  title: PT.string.isRequired,
  shortText: PT.string.isRequired,
  colWidth: PT.number.isRequired,
  images: imagesProp,
  files: PT.arrayOf(PT.string),
})



// WEBPACK FOOTER //
// ./src/propTypes/index.js